import { useCallback, useReducer } from 'react';

/**
 * @param {Object} reducers
 * @param {Object} INITIAL_STATE
 * @returns
 */
export default (reducers, INITIAL_STATE = {}) => {
  const [state, dispatch] = useReducer(reducers, INITIAL_STATE);
  const dispatchHelper = useCallback((type, payload) => {
    dispatch({ type, payload });
  }, []);

  return {
    state,
    dispatchHelper,
  };
};
